import { render, staticRenderFns } from "./TgUserIdField.vue?vue&type=template&id=5e86460d&scoped=true&"
import script from "./TgUserIdField.vue?vue&type=script&lang=js&"
export * from "./TgUserIdField.vue?vue&type=script&lang=js&"
import style0 from "./TgUserIdField.vue?vue&type=style&index=0&id=5e86460d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e86460d",
  null
  
)

export default component.exports